import { Route } from '../models'

import React from 'react'

import CicloBonoLayout from 'layouts/CicloBonoLayout'
import ExternalLayout from 'layouts/ExternalLayout'
import HomeLayout from 'layouts/HomeLayout'
import AppOpener from 'pages/AppOpener'
import Caes from 'pages/CAES'
import Calculator from 'pages/Calculator'
import CicloBono from 'pages/CicloBono'
import ConfirmPassword from 'pages/ConfirmPassword'
import CookiesPolicy from 'pages/CookiesPolicy'
import EmailValidation from 'pages/EmailValidation'
import Feedback from 'pages/Feedback/Feedback'
import KycCallback from 'pages/KycCallback'
import LegalForeverGreen from 'pages/LegalForeverGreen'
import LegalNotice from 'pages/LegalNotice'
import ParticularTerms from 'pages/ParticularTerms'
import PaymentCicloBono from 'pages/PaymentCicloBono'
import PaymentCicloBonoReady from 'pages/PaymentCicloBonoReady'
import PrivacyPolicy from 'pages/PrivacyPolicy'
import QR from 'pages/QR'
import Register from 'pages/Register'
import RegisterConfirmation from 'pages/RegisterConfirmation'
import ResetPassword from 'pages/ResetPassword'
import Review from 'pages/Review/Review'
import { Navigate, useSearchParams } from 'react-router-dom'

const Home = React.lazy(() => import('../pages/Home'))
const Error = React.lazy(() => import('../pages/Error'))

const CompaniesRedirect = () =>
  React.createElement(Navigate, { to: '/', replace: true })

const KycCallbackRedirect: React.FC = () => {
  const [searchParams] = useSearchParams()
  const searchString = searchParams.toString()
  const to = '/kyc/callback' + (searchString ? `?${searchString}` : '')
  return React.createElement(Navigate, { to, replace: true })
}

export const routes: Route[] = [
  {
    path: '/',
    page: Home,
    layout: HomeLayout,
  },
  {
    path: '/companies',
    page: CompaniesRedirect,
    layout: undefined,
  },
  {
    path: '/companies/*',
    page: CompaniesRedirect,
    layout: undefined,
  },
  {
    path: '/terms',
    page: PrivacyPolicy,
    layout: ExternalLayout,
  },
  {
    path: '/terms_app',
    page: ParticularTerms,
    layout: undefined,
  },
  {
    path: '/legal',
    page: LegalNotice,
    layout: ExternalLayout,
  },
  {
    path: '/legalforevergreen',
    page: LegalForeverGreen,
    layout: ExternalLayout,
  },
  {
    path: '/cookies-policy',
    page: CookiesPolicy,
    layout: ExternalLayout,
  },
  {
    path: '/certificados-ahorro-energetico-carpooling-corporativo',
    page: Caes,
    layout: ExternalLayout,
  },
  {
    path: '/ciclo-bono',
    page: CicloBono,
    layout: CicloBonoLayout,
  },
  {
    path: 'user/reset-password/:userUUID/:token',
    page: ResetPassword,
    layout: undefined,
  },
  {
    path: 'user/password-confirm',
    page: ConfirmPassword,
    layout: undefined,
  },
  {
    path: '/qr',
    page: QR,
    layout: undefined,
  },
  {
    path: '/calculator',
    page: Calculator,
    layout: HomeLayout,
  },
  {
    path: '/register',
    page: Register,
    layout: undefined,
  },
  {
    path: '/register-confirmation',
    page: RegisterConfirmation,
    layout: undefined,
  },
  {
    path: '/email-validation',
    page: EmailValidation,
    layout: undefined,
  },
  {
    path: '/app',
    page: AppOpener,
    layout: undefined,
  },
  {
    path: '/kyc/callback',
    page: KycCallback,
    layout: undefined,
  },
  {
    path: '/kyc/callback/kyc_callback.html',
    page: KycCallbackRedirect,
    layout: undefined,
  },
  {
    path: '*',
    page: Error,
    layout: HomeLayout,
  },
  {
    path: '/payment-ciclobono/:token',
    page: PaymentCicloBono,
    layout: undefined,
  },
  {
    path: '/payment-ciclobono/:token/ready',
    page: PaymentCicloBonoReady,
    layout: undefined,
  },
  {
    path: '/feedback',
    page: Feedback,
    layout: undefined,
  },
  {
    path: '/review',
    page: Review,
    layout: undefined,
  },
]
